export const useDataAttributeProps = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string | number | symbol, any>,
) => {
  const dataAttributeKeys = Object.keys(props).filter((key) =>
    key.startsWith('data-'),
  );
  const attributes: Record<`data-${string}`, string> = Object.fromEntries(
    dataAttributeKeys.map((key) => [key, props[key]]),
  );
  return attributes;
};
